/* eslint-disable default-case */
import React, { useEffect, useState } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { Button, Form, Input, Select, Row, Col, InputNumber, Popconfirm, Tag, message } from "antd";
import "./Form.css";

import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  getStorage,
} from "firebase/storage";

import { FolderOpenOutlined } from "@ant-design/icons";

import {
  validatePrice,
  validateObservation,
  validateCode,
} from "./validations";

import { checkValueFirebase, collections } from "../../../utils";

const { Option } = Select;
const { TextArea } = Input;

export const StepThree = ({
  onSubmit,
  setDataFormSale,
  dataFormSale,
  order,
  prev,
}) => {
  const querydb = getFirestore();

  const mapDocs = (res) => {
    return res.docs.map((ele) => ({ id: ele.id, ...ele.data() }));
  };

  const [confirmVisible, setConfirmVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isDisabledBack, setIsDisabledBack] = useState(false);
  const [paymenttype, setPaymenttype] = useState();

  useEffect(() => {
    getDocs(collection(querydb, "paymenttype")).then((res) => {
      setPaymenttype(mapDocs(res));
    });
  }, [querydb]);

  const [form] = Form.useForm();
  const fields = form.getFieldsValue('stepThree');


  const onFinish = (values) => {
    setDataFormSale({ ...values });
    setSaleTotal(Number(values.shippingAmount));
    onSubmit({
      ...values,
      paymenttype: values.paymenttype.toUpperCase(),
      remarks: values.remarks ? values.remarks.toUpperCase() : null,
      shippingAmount: Number(fields.shippingAmount),
      advanceDelivery: Number(fields.advanceDelivery),
      saleAmount: Number(saleTotal),
      payable: Number(payable),
      paymentCode: values.paymentCode ? values.paymentCode.toUpperCase() : ""
    }, fileImage);
    form.resetFields();
  };

  const onSumit = () => {
    prev();
    setDataFormSale({
      ...fields,
    });
  };

  const orderAmount = order ? order.map((product) => Number(product.total)).reduce((a, b) => a + b) : 0
  const [saleTotal, setSaleTotal] = useState(orderAmount);
  const [payable, setPayable] = useState(orderAmount);
  const [courierFee, setCourierFee] = useState(0);
  const [prepaid, setPrepaid] = useState(0);
  const [fileImage, setFileImage] = useState("");
  const [fileError, setFileError] = useState("");
  const [isValidCode, setIsValidCode] = useState(false);
  const [codeStatus, setCodeStatus] = useState("Codigo de operacion sin validar");

  // progress
  const [percent, setPercent] = useState(0);
  const [nameFile, setNameFile] = useState("");
  // Handle file upload event and update state
  function handleChange(event) {
    let file = event.target.files[0];

    // check if file is jpeg or png image to allow upload
    if (!(file.type.startsWith('image/jpeg') || file.type.startsWith('image/png'))) {
      setFileError("Solamente se permiten extensiones .jpg, .jpeg y .png");
    } else {
      const storage = getStorage();

      const storageRef = ref(storage, `${file.name}`);
      setNameFile(`${file.name}`);

      const uploadTask = uploadBytesResumable(storageRef, file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          // update progress
          setPercent(percent);
        },
        (err) => console.log(err),
        () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            setFileImage({ fileImage: url });
          });
        }
      );
    }
  }

  const checkCode = async (code) => {
    const codeExists = await checkValueFirebase(querydb, collections.orders, "paymentCode", form.getFieldValue("paymentCode").toUpperCase());
    if (codeExists) {
      setCodeStatus("Codigo de operacion ya fue registrado");
      setIsValidCode(false);
    } else {
      setCodeStatus("Codigo de operacion valido");
      setIsValidCode(true);
    }
  }

  const updateForm = (changedValues, allValues) => {

    const { shippingAmount, advanceDelivery } = allValues;
    setCourierFee(Number(shippingAmount));
    setPrepaid(Number(advanceDelivery));
    setSaleTotal(Number(orderAmount));
    setPayable((orderAmount + shippingAmount) - advanceDelivery);

    if (allValues.paymenttype) {
      setIsDisabled(false);
    }

  }

  const checkData = () => {
    if (form.getFieldValue("paymenttype") === "Contraentrega" && payable === 0) {
      setIsDisabled(true);
      message.error("No se puede registrar metodo de pago contraentrega y pendiente por pagar en cero");
    } else {
      setConfirmVisible(true);
    }
  }

  const handleConfirm = () => {
    if (!(form.getFieldValue("paymenttype") === "Contraentrega" && payable === 0)) {
      setIsDisabled(true);
      setIsDisabledBack(true);
      setConfirmLoading(true);
      setTimeout(() => {
        form.submit();
        setConfirmVisible(false);
        setConfirmLoading(false);
      }, 2000);
    } else {
      message.error("No se puede registrar metodo de pago contraentrega y pendiente por pagar en cero");
    }
  };

  const handleCancel = () => {
    setConfirmVisible(false);
  };

  return (
    <Form
      form={form}
      name="stepThree"
      onFinish={onFinish}
      initialValues={dataFormSale}
      onValuesChange={updateForm}
    >
      <h3 className="titles-form">Información de la Venta </h3>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="paymenttype"
            label="Tipo de Pago"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
            ]}
          >
            <Select placeholder="Seleccione una opcion">
              {paymenttype &&
                paymenttype?.map((storage, i) => {
                  return (
                    <Option
                      key={i}
                      value={storage.name}
                      label={storage.name}
                      name={storage.name}
                    >
                      {storage.name}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="remarks"
            label="Datos de entrega"
            rules={[
              {
                required: false,
              },
              {
                validator: validateObservation
              }
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="shippingAmount"
            label="Cobro de envio"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
              {
                validator: validatePrice
              }
            ]}
            initialValue={0}
          >
            <InputNumber min={0} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={24} lg={12}>
          <p>+ Costo de envio : ${courierFee.toFixed(2)}</p>
          <p>+ Monto de venta : ${saleTotal.toFixed(2)}</p>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="advanceDelivery"
            label="Adelanto de pago"
            rules={[
              {
                required: true,
                message: "Campo requerido",
              },
              {
                validator: validatePrice
              }
            ]}
            initialValue={0}
          >
            <InputNumber min={0} max={parseFloat((saleTotal + courierFee).toFixed(2))} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <p>- Adelanto: ${prepaid.toFixed(2)}</p>
          <p>= Pendiente por pagar : ${payable.toFixed(2)}</p>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Form.Item
            name="paymentCode"
            label="codigo de pago"
            rules={[
              {
                message: "Codigo requerido"
              },
              {
                validator: validateCode
              }
            ]}
            hasFeedback
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12}>
          <Button type="primary" onClick={checkCode}>Validar codigo</Button>
          <br /><br />
          <Tag color={isValidCode ? "green" : "red"}>{codeStatus}</Tag>
          <br /><br />
        </Col>
      </Row>
      <Row gutter={16}>
        <label className={nameFile ? "filelabelcheck" : "filelabel"}>
          <FolderOpenOutlined />
          <br />
          <span className="title">Elegir archivo</span>
          <input
            id="FileInput"
            type="file"
            onChange={handleChange}
            accept="/image/*"
          />
          {!fileError.length ? null : <p>{fileError}</p>}
          <p>{nameFile}</p>
          <p>{percent}% cargado</p>
        </label>
      </Row>
      <div className="container-buttons-form">
        <div className="button-form">
          <Button size="large" onClick={() => onSumit()} disabled={isDisabledBack}>Regresar</Button>
        </div>
        <Form.Item className="button-form">
          <Popconfirm
            title="Registra venta ?"
            open={confirmVisible}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            okButtonProps={{
              loading: confirmLoading,
            }}
            okText="Si"
            cancelText="No"
          >
            <Button type="primary" size="large" onClick={checkData} disabled={isDisabled}>
              Enviar
            </Button>
          </Popconfirm>
        </Form.Item>
      </div>
    </Form>
  );
};
